<template>
  <div>
    <Modal
      :close-on-outside-click="!pending"
      :is-full-mobile="true"
      :initial-open="true"
      :identifier="identifier"
    >
      <div v-if="pending" class="text-center">
        <Spinner background="bg-dark" />
        <h1>{{ t.title }}</h1>
        <p>{{ t.info }}</p>
      </div>
      <div v-else class="text-center">
        <h1>{{ t.title_error }}</h1>
        <p>{{ t.info_error }}</p>
        <button @click="close" class="btn btn-primary mt-3">{{ t.button_error }}</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "./Modal";
import Spinner from "./Spinner";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AsyncPaymentModal",
  components: { Modal, Spinner },
  props: {
    orderId: {
      type: String,
      required: true,
    },
    successUrl: {
      type: String,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loop: null,
      pending: true,
      identifier: "async-payment-modal",
      checkIntervalInMs: 2000,
      checkDurationInMs: 600 * 1000,
    };
  },
  computed: {
    ...mapGetters({
      orderCompletedAt: "checkout/orderCompletedAt",
    }),
  },
  mounted() {
    this.loop = setInterval(this.checkPayment, this.checkIntervalInMs);
    setTimeout(this.cancel, this.checkDurationInMs);
  },
  methods: {
    ...mapActions({
      hideModal: "hideModal",
    }),
    checkPayment() {
      this.$store.dispatch("checkout/fetchOrderCompletedAt", this.orderId);

      if (this.orderCompletedAt) {
        clearInterval(this.loop);
        window.location.assign(this.successUrl);
      }
    },
    cancel() {
      clearInterval(this.loop);
      this.pending = false;
    },
    close() {
      this.hideModal(this.identifier);
    },
  },
};
</script>
